<template>
  <div class="d-flex pl-2">
    <v-spacer></v-spacer>
    <v-card
      class="pa-3 ma-2 text-left"
      style="
        position: relative;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
        border-radius: 20px 20px 5px 20px;
        max-width: 85%;
        background-color: #e3f2fd;
      "
    >
      <div class="d-flex align-center mb-2">
        <v-icon small color="primary" class="mr-2">mdi-account</v-icon>
        <span class="caption font-weight-bold primary--text">Você</span>
      </div>

      <div class="message-content" v-html="formattedContent"></div>

      <div class="d-flex justify-end mt-2">
        <span class="caption grey--text">
          {{ formatTime(message.createdAt) }}
        </span>
      </div>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'AIUserMessage',

  props: {
    message: {
      type: Object,
      required: true,
      default: () => ({
        content: '',
        createdAt: '',
        role: 'User',
      }),
    },
  },

  computed: {
    formattedContent() {
      if (!this.message.content) return ''

      // Convert line breaks to HTML
      return this.message.content
        .replace(/\n/g, '<br>')
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') // Bold text
        .replace(/\*(.*?)\*/g, '<em>$1</em>') // Italic text
    },
  },

  methods: {
    formatTime(dateTime) {
      if (!dateTime) return ''

      const now = moment()
      const messageTime = moment(dateTime)

      if (now.diff(messageTime, 'minutes') < 1) {
        return 'Agora'
      } else if (now.diff(messageTime, 'hours') < 1) {
        return `${now.diff(messageTime, 'minutes')} min atrás`
      } else if (now.diff(messageTime, 'days') < 1) {
        return messageTime.format('HH:mm')
      } else {
        return messageTime.format('DD/MM/YYYY HH:mm')
      }
    },
  },
}
</script>

<style scoped>
.message-content {
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  line-height: 1.4;
  color: #333;
  word-wrap: break-word;
}

.message-content ::v-deep strong {
  font-weight: 600;
}

.message-content ::v-deep em {
  font-style: italic;
}
</style>
